import EcoImg from 'eco-design/base/eco-img';
import { ItfCartCartIconMap, ItfEcoCartIcon } from './type.d';
import { IconEcoCart } from './icons';
import './index.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from '../../type.d';
import useEcoCart from '../../useEcoCart';
import { HAS_ECOCART_ICON_MAP } from './config';
import { useEffect, useState } from 'react';
import getLocal from 'eco-design-reliance/getLocal';
import { MAX_CART_NUM } from '../../const';

const EcoCartIcon: React.FC<ItfEcoCartIcon> = ({ url = '', callback }) => {
    const { items, icon, isLogin } = useEcoCart();
    const [total, setTotal] = useState<number>(0);
    const { locale = '', pathname } = getLocal();
    const [show, setShow] = useState<boolean>(false);
    const [enterTimes, setEnterTimes] = useState<number>(0);

    const handleOpenCart = () => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_OPEN, true);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // 固定页面展示
            const isShowPage = HAS_ECOCART_ICON_MAP?.find((item: ItfCartCartIconMap) => item.path === pathname && item.sites?.includes(locale));
            // 配置化组件展示
            const isShowComp = icon === `/${locale}${pathname}`;
            // 首次进入且购物车无数据时不展示侧边栏购物车挂件icon
            const isFirstEmpty = enterTimes <= 0 && total <= 0;

            const finalShow = (Boolean(isShowPage) || Boolean(isShowComp)) && !isFirstEmpty;
            setShow(finalShow);
            callback(finalShow);
        }
    }, [icon, locale, pathname, total]);

    useEffect(() => {
        setTotal(items?.reduce((prev: number, cur: ItfEcoCartItem) => prev + cur.quantity, 0));
        setEnterTimes(enterTimes + 1);
    }, [JSON.stringify(items), isLogin]);

    return (
        <>
            {show && (
                <div className={`eco-cart-icon ${url ? 'is-img' : 'is-default'}`} data-btn-id="widgets-cart" onClick={handleOpenCart}>
                    {/* 后台未开放配置url, 由于存在历史脏数据的url，这里暂不能使用EcoImg */}
                    {/* {url ? <EcoImg pc={url} alt={'EcoFlow Shopping Cart Icon'} /> : IconEcoCart} */}
                    {IconEcoCart}
                    {total > 0 && <span className={`eco-cart-icon-num${total > MAX_CART_NUM ? ` over` : ''}`}>{total > MAX_CART_NUM ? `···` : total}</span>}
                </div>
            )}
        </>
    );
};

export default EcoCartIcon;
